export default {
  LookupQueryString: 'language',
  LookupCookie: 'i18next',
  LookupLocalStorage: 'i18nextLng',
  LookupSessionStorage: 'i18nextLng',
}
